import React from 'react';
import './i18n';
// **** Main CSS **** //
import './assets/scss/main.scss';
import Navigation from './navigation';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Provider } from 'react-redux';
import store from './store';
import { GoogleOAuthProvider } from '@react-oauth/google';
import MaintaincePageProvider from './pages/503/provider';
import { LoadScript } from '@react-google-maps/api';
import { ToastProvider } from './context/ToastContext';
import { PrimeReactProvider } from 'primereact/api';
import CookieBanner from './components/auth/CookieBanner';
import { useMediaQuery } from '@react-hook/media-query';

const lib = ['places']
const apiKey  = process.env.REACT_APP_GOOGLE_MAP_API_KEY;

function App() {
  const queryClient = new QueryClient();
  const isMobile = useMediaQuery('only screen and (max-width: 768px)');
  return (
    <PrimeReactProvider>
    <Provider store={store} >
      <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_AUTH_CLIENT_KEY}>
        <QueryClientProvider client={queryClient}>
          <LoadScript  scriptjs={false} googleMapsApiKey={apiKey} libraries={lib} loadingElement={<></>}>
            <ToastProvider>
              <MaintaincePageProvider>
                <Navigation />
                {!isMobile && <CookieBanner />}
              </MaintaincePageProvider>
            </ToastProvider>
          </LoadScript>
        </QueryClientProvider>
      </GoogleOAuthProvider>
    </Provider>
    </PrimeReactProvider>
  );
}

export default App;